<!-- 贸易订单列表（贸易AI助手档案表头） -->
<template>
    <div style="display: flex;flex-direction: column; overflow: hidden;height: calc(100vh - 85px) ; background-color: #ffffff;">
        <!-- 查询区 -->
        <div style="flex-shrink: 0;">
            <el-form class="demo-form-inline" :inline="true" ref="tradeOrderSeach" :model="tradeOrderSeach" size="mini"
                label-width="90px">
                <el-form-item label="提单号" prop="blNo">
                    <el-input v-model.trim="tradeOrderSeach.blNo" placeholder="请输入提单号" clearable
                        @keyup.enter.native="searchList"></el-input>
                </el-form-item>
                <el-form-item label="批次号" prop="batchNo">
                    <el-input v-model.trim="tradeOrderSeach.batchNo" placeholder="请输入批次号" clearable
                        @keyup.enter.native="searchList"></el-input>
                </el-form-item>
                <el-form-item label="目的国" prop="country">
                    <el-select v-model="tradeOrderSeach.country" placeholder="请选择目的国(地区)" clearable filterable remote :remote-method="getCountryList">
                        <el-option v-for="item in countryList" :key="item.codeValue + '-' + item.cusCode"
                            :label="item.codeName" :value="item.codeName">
                                <span class="gw-opt-code">{{ item.codeValue }}</span>
                                <span class="gw-opt-name">{{ item.codeName }}</span>
                                <span>{{ item.cusCode }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建人" prop="createMan">
                    <el-input v-model.trim="tradeOrderSeach.createMan" placeholder="请输入创建人" clearable
                        @keyup.enter.native="searchList"></el-input>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate">
                    <el-date-picker v-model="createDate" clearable value-format="yyyy-MM-dd" type="daterange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        @change="getCreateDate"></el-date-picker>
                </el-form-item>
                <el-form-item label="">
                    <el-button size="mini" @click="resetForm">重置</el-button>
                    <el-button type="primary" size="mini" @click="searchList">搜索</el-button>
                    <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="batchDelete">删除</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 表格区 -->
        <div style="flex: 1; overflow: hidden;">
            <vxe-table id="tradeOrderTable" ref="tradeOrderTable" size="mini" :data="tradeOrderList" border stripe
                :column-config="{ resizable: true, sortable: true }" header-align="center"
                :row-config="{ isHover: true, isCurrent: true }" height="auto"
                :checkbox-config="{ labelField: '', highlight: true }"
                @checkbox-all="tradeOrderTableRowsCheckbox" @checkbox-change="tradeOrderTableRowsCheckbox">
                <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="blNo" title="提单号" min-width="220" fixed="left" show-overflow align="center">
                    <template #default="{ row }">
                        <el-link type="primary" :underline="false" >{{ row.blNo }}</el-link>
                    </template>
                </vxe-column>
                <vxe-column field="batchNo" title="批次号" min-width="220" show-overflow align="center"></vxe-column>
                <vxe-column field="country" title="目的国" width="150" show-overflow align="center"></vxe-column>
                <vxe-column field="createMan" title="创建人" width="130" show-overflow align="center"> </vxe-column>
                <vxe-column field="createDate" title="创建日期" width="160" align="center"></vxe-column>
                <!-- <vxe-column field="id" title="档案ID" min-width="180" show-overflow></vxe-column> -->
                <vxe-column field="cnElementStatus" title="要素规范" min-width="180" show-overflow align="center">
                    <template #default="{ row }">
                        <el-button type="text" size="mini"  @click="getAiEleCheckReportBy(row)">{{ row.cnElementStatus }}</el-button>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="200" fixed="right" align="center">
                    <template #default="{ row }">
                        <el-button type="primary" size="mini" plain @click="aiElement(row)">AI操作规范</el-button>
                        
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <!-- 分页 -->
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize"
            :page-sizes="pageSizes" :total="pagination.total" @page-change="getTradeOrderListPager" size="mini">
        </vxe-pager>
        <!-- 申报要素AI规范报告 -->
        <el-dialog v-dialogDrag title="申报要素AI规范报告" :visible.sync="AiEleCheckReportVisible"
            :before-close="AiEleCheckReportClose" :close-on-click-modal="false" width="60%">
            <el-descriptions title="" :column="1" border>
                <el-descriptions-item label="判定结果">
                    <el-tag v-if="AiEleCheckReport.summary === '缺失要素'" type="danger">{{ AiEleCheckReport.summary }}</el-tag>
                    <el-tag v-else-if="AiEleCheckReport.summary" type="success">{{ AiEleCheckReport.summary }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="生成时间">
                    {{ AiEleCheckReport.createTime ? AiEleCheckReport.createTime.split('T')[0] + '  ' + AiEleCheckReport.createTime.split('T')[1] : '' }}
                </el-descriptions-item>
                <el-descriptions-item label="具体说明">
                    <div class="contentList">
                        <div v-for="(item, index) in AiEleCheckReport.contentList" :key="index">
                            <span v-if="item.includes('缺少')" class="red">
                                {{ item }}
                            </span>
                            <span v-else>
                                {{ item }}
                            </span>
                        </div>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="AiEleCheckReportClose">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'
export default {
    name: 'tradeOrderList',
    data() {
        return {
            // 查询条件（blNo/batchNo/country/createMan/日期区间，均可空）
            tradeOrderSeach: {
                blNo: '', // 提单号
                batchNo: '', // 批次号
                country: '', // 目的国(地区)
                createMan: '', // 创建人
                startDate: '', // 创建日期(开始)
                endDate: '', // 创建日期(结束)
            },
            createDate: [], // 创建日期区间
            // 目的国数据源：与出口报关单表体「最终目的国」一致
            countryList: AEObasicData.CUS_MAPPING_COUNTRY_CODE_V,
            tradeOrderList: [], // 档案表头列表
            tradeOrderCheckbox: [], // 表格勾选的档案表头
            // 分页信息
            pagination: {
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 20, // 每页显示多少条数据
            },
            pageSizes: [10, 15, 20, 50, 100],
            AiEleCheckReport: {}, // 申报要素AI规范报告
            AiEleCheckReportVisible: false, // 申报要素AI规范报告弹窗
        }
    },
    created() {
        this.getTradeOrderList()
    },
    methods: {
        // 创建日期获取
        getCreateDate(data) {
            if (data === null) {
                this.tradeOrderSeach.startDate = ''
                this.tradeOrderSeach.endDate = ''
            } else {
                this.tradeOrderSeach.startDate = data[0]
                this.tradeOrderSeach.endDate = data[1]
            }
        },
        // 重置查询条件
        resetForm() {
            this.tradeOrderSeach = {
                blNo: '',
                batchNo: '',
                country: '',
                createMan: '',
                startDate: '',
                endDate: '',
            }
            this.createDate = []
        },
        // 目的国查询
        getCountryList(value){
            if(value && value !== ' '){
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase()) || 
                    item.cusCode.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 搜索：从第一页开始查
        searchList() {
            this.pagination.currentPage = 1
            this.getTradeOrderList()
        },
        // 分页查询档案表头（按保存日期、id 倒序）
        getTradeOrderList() {
            this.$api.tradeaiHeadList(this.pagination.currentPage, this.pagination.pageSize, this.tradeOrderSeach).then(res => {
                this.tradeOrderList = (res && res.records) || []
                this.pagination.total = (res && res.total) || 0
                this.pagination.currentPage = (res && res.current) || this.pagination.currentPage
                this.pagination.pageSize = (res && res.size) || this.pagination.pageSize
                // 列表刷新后清空勾选，避免残留已删除的行
                this.tradeOrderCheckbox = []
                this.$nextTick(() => {
                    if (this.$refs.tradeOrderTable) {
                        this.$refs.tradeOrderTable.clearCheckboxRow()
                    }
                })
            })
        },
        // 翻页/切换每页条数
        getTradeOrderListPager() {
            this.getTradeOrderList()
        },
        // 多选档案表头
        tradeOrderTableRowsCheckbox() {
            const selectedRecords = this.$refs.tradeOrderTable.getCheckboxRecords()
            this.tradeOrderCheckbox = selectedRecords
        },
        // 批量删除档案表头（逻辑删除，级联删除同批次号的明细）
        batchDelete() {
            if (this.tradeOrderCheckbox.length === 0) {
                this.$message.error('请选择要删除的档案')
                return false
            }
            this.$confirm('是否删除选中的 ' + this.tradeOrderCheckbox.length + ' 条档案?删除后对应的明细也会一并删除。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = this.tradeOrderCheckbox.map(item => String(item.id))
                this.$api.tradeaiHeadDelete(params).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    // 整页删空时回退一页
                    if (this.tradeOrderList.length === params.length && this.pagination.currentPage > 1) {
                        this.pagination.currentPage = this.pagination.currentPage - 1
                    }
                    // 刷新列表
                    this.getTradeOrderList()
                })
            }).catch(() => {
            })
        },
        // AI操作规范：触发一票的申报要素AI规范（接口提交线程池后立即返回，稍后刷新列表查看结果）
        aiElement(row) {
            this.$api.tradeaiHeadElement(row.id).then(res => {
                const message = (res && res.message) ? String(res.message) : '已提交AI规范任务，稍后刷新列表查看结果'
                this.$alert(message.replace(/[\n\r]+/g, '<br>'), '提示', {
                    dangerouslyUseHTMLString: true
                })
            })
        },
        // 提单号点击：查询该票的申报要素AI规范报告
        getAiEleCheckReportBy(row) {
            this.$api.getAiEleCheckReportBy(row.id).then(res => {
                // 未查到报告（接口未返回数据）时给出警告提示
                if (!res || !res.id) {
                    this.$message({
                        message: '未查询到该票的申报要素AI规范报告，请先点击「AI操作规范」生成后再查看',
                        type: 'warning'
                    })
                    return
                }
                this.AiEleCheckReport = res
                this.AiEleCheckReport.contentList = (res.content || '').split('。').map(item => item.trim()).filter(item => item)
                this.AiEleCheckReportVisible = true
            })
        },
        // 关闭申报要素AI规范报告
        AiEleCheckReportClose() {
            this.AiEleCheckReportVisible = false
            this.AiEleCheckReport = {}
        },
    },
}
</script>
<style lang="less" scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.gw-opt-code {
    margin-right: 16px;
    color: #909399;
}
.gw-opt-name {
    margin-right: 16px;
}
::v-deep .el-descriptions-item__label.is-bordered-label {
    width: 100px;
}
.contentList {
    max-height: 350px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 2;
}
.red {
    color: red;
    font-weight: 500;
}
</style>
